import React, { useState, useEffect } from "react";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidemenu";

const Segment = () => {
  const navigate = useNavigate();
  const [savedDetails, setSavedDetails] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleNewButtonClick = () => {
    navigate("/newsegment");
  };

  const handleEditClick = (name, conditions) => {
    navigate(
      `/newsegment?name=${name}&conditions=${encodeURIComponent(
        JSON.stringify(conditions)
      )}`
    );
  };

  const handleViewClick = async (name, conditions) => {
    try {
      const conditionsArray = conditions.split(" and ").map((condition) => {
        const [selectedOption, operator, filterValue] = condition
          .split(/([=<>!]+)/)
          .filter(Boolean);
        const filterType = mapOperatorToFilterType(operator);
        return {
          selectedOption: mapSelectedOption(selectedOption),
          filterType,
          filterValue,
        };
      });

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/userdetails/view`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ conditions: conditionsArray }),
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setFilteredUsers(responseData.filteredUsers);
      } else {
        console.error(
          "Error fetching filtered user details for view:",
          response.statusText
        );
      }
    } catch (error) {
      console.error(
        "An error occurred during fetching filtered user details for view:",
        error
      );
    }
  };

  // Function to map operators to filter types
  function mapOperatorToFilterType(operator) {
    switch (operator) {
      case "=":
        return "equal";
      case "!=":
        return "notEqual";
      case ">":
        return "greaterThan";
      case ">=":
        return "greaterThanOrEqual";
      case "<":
        return "lessThan";
      case "<=":
        return "lessThanOrEqual";
      default:
        return "";
    }
  }

  // Function to map selectedOption values
  function mapSelectedOption(selectedOption) {
    switch (selectedOption) {
      case "Name":
        return "user_name";
      case "Email":
        return "user_emailid";
      case "Phone":
        return "user_phonenumber";
      case "Country":
        return "user_country";
      case "Gender":
        return "user_gender";
      case "Age":
        return "user_age";
      default:
        return selectedOption;
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/saveddetails`
        );
        const data = await response.json();
        setSavedDetails(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching saved details:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDeleteClick = async (name) => {
    try {
      // Delete from frontend
      const updatedDetails = savedDetails.filter(
        (segment) => segment.name !== name
      );
      setSavedDetails(updatedDetails);

      // Delete from backend
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/saveddetails/${name}`, {
        method: "DELETE",
      });
    } catch (error) {
      console.error("Error deleting saved details:", error);
    }
  };

  return (
    <div className="container-fluid" style={{ display: "flex" }}>
      <Sidebar />
      <div
        className="segment-container"
        style={{ width: "100%", height: "100vh", overflowY: "auto" }}
      >
        <div style={{ marginTop: "50px" }}>
          <div
            style={{ display:'flex',justifyContent:'space-between', marginLeft: "5%" }}
          >
            <h1>Contact Segment</h1>
            <button
              style={{ width: "10%" }}
              onClick={handleNewButtonClick}
            >
              <FaPlus /> New
            </button>
          </div>

            <div
              style={{ marginLeft: "30px",display:'flex' }}
            >
              <span className="input-group-text" id="basic-addon1" style={{width:'50px'}}>
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Filter.."
                aria-label="Filter"
                aria-describedby="basic-addon1"
                style={{width:'30%'}}
              />
            </div>

          {isLoading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-bordered"
                style={{ marginLeft: "30px", marginTop: "30px", width: "40%" }}
              >
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" />
                    </th>
                    <th>S.no</th>
                    <th>Name</th>
                    <th>User Details</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(savedDetails) ? (
                    savedDetails.map((segment, index) => (
                      <tr key={index}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>{index + 1}</td>
                        <td>{segment.name}</td>
                        <td>
                          <span
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={() =>
                              handleViewClick(segment.name, segment.conditions)
                            }
                          >
                            <i
                              className="fas fa-eye"
                              style={{ marginRight: "5px" }}
                            ></i>{" "}
                            View
                          </span>
                        </td>
                        <td>
                          <FaEdit
                            style={{ cursor: "pointer", color: "green" }}
                            onClick={() =>
                              handleEditClick(segment.name, segment.conditions)
                            }
                          />
                        </td>
                        <td>
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleDeleteClick(segment.name)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">
                        Invalid data format for saved details.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {filteredUsers.length > 0 && (
            <div className="filtered-users">
              <h2>Filtered Users</h2>
              <ul>
                {filteredUsers.map((user, index) => (
                  <li key={index}>
                    <strong>User ID:</strong> {user.user_id}
                    <br />
                    <strong>Name:</strong> {user.user_name}
                    <br />
                    <strong>Email:</strong> {user.user_emailid}
                    <br />
                    <strong>Phone Number:</strong> {user.user_phonenumber}
                    <br />
                    <strong>Country:</strong> {user.user_country}
                    <br />
                    <strong>Age:</strong> {user.user_age}
                    <br />
                    <strong>Gender:</strong> {user.user_gender}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {savedDetails.length === 0 && !isLoading && (
            <p>No details saved yet.</p>
          )} 
        </div>
      </div>
    </div>
  );
};

export default Segment;
